import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { logRocketService } from './lib/logrocket';
// Debug utility removed - LogRocket issues resolved

// LogRocket console capture is working correctly

// Initialize LogRocket after CSS loads to ensure proper UI capture
const initLogRocketAfterCSS = () => {
  // Wait for all stylesheets to load
  const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'));

  if (stylesheets.length === 0) {
    // No external stylesheets, init immediately
    logRocketService.init();
    return;
  }

  Promise.all(
    stylesheets.map((link: Element) => {
      const linkElement = link as HTMLLinkElement;
      if (linkElement.sheet) return Promise.resolve(); // Already loaded
      return new Promise<void>(resolve => {
        linkElement.addEventListener('load', () => resolve());
        linkElement.addEventListener('error', () => resolve()); // Don't block on errors
      });
    })
  ).then(() => {
    // Extra delay to ensure CSS is applied to DOM
    setTimeout(() => {
      console.log('[LogRocket] Initializing after CSS loaded');
      logRocketService.init();
    }, 100);
  });
};

// Start LogRocket initialization with CSS timing
initLogRocketAfterCSS();

// Wrap app initialization in try-catch
try {
  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  const root = createRoot(rootElement);
  root.render(<App />);
} catch (error) {
  console.error('Failed to initialize app:', error);

  // Fallback UI
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; font-family: system-ui, -apple-system, sans-serif; padding: 20px;">
        <h1 style="font-size: 24px; margin-bottom: 16px;">Application Error</h1>
        <p style="color: #666; margin-bottom: 24px;">We're having trouble loading the application.</p>
        <button onclick="window.location.reload()" style="padding: 8px 16px; background: #3b82f6; color: white; border: none; border-radius: 4px; cursor: pointer;">
          Reload Page
        </button>
      </div>
    `;
  }
}
